module.exports = __webpack_public_path__ + "img/cough-mobile.634a900d.png";